var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00016 13.6663H13.0002C13.177 13.6663 13.3465 13.5961 13.4716 13.4711C13.5966 13.3461 13.6668 13.1765 13.6668 12.9997V2.99967C13.6668 2.82286 13.5966 2.65329 13.4716 2.52827C13.3465 2.40325 13.177 2.33301 13.0002 2.33301H10.3335V0.999674C10.3335 0.822863 10.2633 0.653294 10.1382 0.52827C10.0132 0.403246 9.84364 0.333008 9.66683 0.333008C9.49002 0.333008 9.32045 0.403246 9.19543 0.52827C9.0704 0.653294 9.00016 0.822863 9.00016 0.999674V2.33301H5.00016V0.999674C5.00016 0.822863 4.92992 0.653294 4.8049 0.52827C4.67988 0.403246 4.51031 0.333008 4.3335 0.333008C4.15669 0.333008 3.98712 0.403246 3.86209 0.52827C3.73707 0.653294 3.66683 0.822863 3.66683 0.999674V2.33301H1.00016C0.823352 2.33301 0.653782 2.40325 0.528758 2.52827C0.403734 2.65329 0.333496 2.82286 0.333496 2.99967V12.9997C0.333496 13.1765 0.403734 13.3461 0.528758 13.4711C0.653782 13.5961 0.823352 13.6663 1.00016 13.6663ZM1.66683 3.66634H12.3335V5.66634H1.66683V3.66634ZM1.66683 6.99967H12.3335V12.333H1.66683V6.99967Z",
    fill: "#67737E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.0de837d7.svg";
export { ForwardRef as ReactComponent };